import { render, staticRenderFns } from "./ReportingOverview.vue?vue&type=template&id=35442a40&scoped=true"
import script from "./ReportingOverview.vue?vue&type=script&lang=js"
export * from "./ReportingOverview.vue?vue&type=script&lang=js"
import style0 from "./ReportingOverview.vue?vue&type=style&index=0&id=35442a40&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35442a40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35442a40')) {
      api.createRecord('35442a40', component.options)
    } else {
      api.reload('35442a40', component.options)
    }
    module.hot.accept("./ReportingOverview.vue?vue&type=template&id=35442a40&scoped=true", function () {
      api.rerender('35442a40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting-web/ReportingOverview.vue"
export default component.exports